/* Info Component in SeriesPage */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../styles/Callsheets.module.css";

const Info3 = () => {
  return (
  <>
    <div className='mb-5'>
    <Row className='mb-3'>
        <Col className={`px-3 pt-1 ${styles.SubTitle6 }`} md={{span: 10, offset: 1 }}>
        <h5 className={`text-center pb-2 ${styles.Red }`} >PRODUCTION FLOW</h5> 
        <hr className={`mt-0`}/>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create <span className={`${styles.Red}`}>Scenes</span> in the Scenes Workspace, one for each Heading in the Script
        and add the <span className={`${styles.Red}`}>Characters and Locations</span> to both the Project and each Scene. 
        This can be done by either the Production or Creative side.
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> Register <span className={`${styles.Red}`}>Admin and Crew</span> Users in Manage Users and
         add the Crew details to the Crew Info page.
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> Register <span className={`${styles.Red}`}>Cast</span> Users in Manage Users and
         add the Actor's details to their Character's Edit page. 
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> On registering each User assign them a <span className={`${styles.Red}`}>Permission</span>, specific details 
        of which are on the Manage Users Info page.
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> In brief, Cast Users should be given the Cast Permission,
        Crew members with Add/Update/Delete access to Platform features 
          should be given either Admincreative, Admin or Superadmin Permissions and all 
          other Crew should be given the Crew Permission.
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create Shoot Day<span className={`${styles.Red}`}> Stripboards</span> in 
          the Schedule section which autofills details from the Scene Breakdown and the
          Locations pages.
        </p>
        <p className='mt-2'><span className={`${styles.Red}`}>*</span> Create <span className={`${styles.Red}`}>Callsheets</span> in 
          the Callsheets section which autofills details from the Schedule.
        </p>
        <hr />
        </Col>
    </Row>
    </div>
  </>
  ) 
}

export default Info3